import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    fontWeight: 'bold',
    padding: theme.spacing(2),
  },
}));
